export default __webpack_public_path__ + "static/2-598671bd016087ec03c44f563e52c9ea.jpg";